import React from 'react';
export default function CompareTab() {
  return (
    <div className="alert alert-secondary mt-4">Compare feature coming soon.</div>
  );
}